export default function IconLocationMap({ width = "16", height = "16" }) {
  return (
    <svg
      viewBox="0 0 16 16"
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        d="M15.6423 1.38887C15.9874 0.563832 15.1588 -0.264789 14.3338 0.0803889L-0.000341757 6.07749L-0.00034142 6.9906L6.29496 9.4277L8.73206 15.723H9.64516L15.6423 1.38887Z"
        fill="var(--greenLight-color)"
      ></path>
    </svg>
  );
}
